import { appConfig } from "@/app-config";
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

type AppointmentUrls = Record<string, string>;

export function getAppointmentUrl(locale: string): string {
  const urls = (appConfig.appointmentUrls ?? {}) as AppointmentUrls;

  if (typeof urls[locale] === "string" && urls[locale].length > 0) {
    return urls[locale];
  }

  const short = locale.split("-")[0];
  if (typeof urls[short] === "string" && urls[short].length > 0) {
    return urls[short];
  }

  return appConfig.defaultAppointmentUrl;
}
